module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av274-a576d4fe5d2f138610c36f2c5404bac2.jpg";